import { http } from './http';
import { ROUTES } from './config';
import type { DemandMetrics, JobsMetrics, RevenueMetrics, WorkerMetric } from '../types/domain';

/** AnalyticsService client (event-projection dashboards). manager+. */
export const analyticsApi = {
  revenue(from: string, to: string): Promise<RevenueMetrics> {
    return http.get(`${ROUTES.analytics}/revenue?from=${from}&to=${to}`);
  },

  jobs(from: string, to: string): Promise<JobsMetrics> {
    return http.get(`${ROUTES.analytics}/jobs?from=${from}&to=${to}`);
  },

  workers(from: string, to: string): Promise<{ from: string; to: string; workers: WorkerMetric[] }> {
    return http.get(`${ROUTES.analytics}/workers?from=${from}&to=${to}`);
  },

  demand(from: string, to: string): Promise<DemandMetrics> {
    return http.get(`${ROUTES.analytics}/demand?from=${from}&to=${to}`);
  },
};
